module.exports = __webpack_public_path__ + "static/media/1.3 Vinckboons Detail.d26d41bf.jpg";